// React-Router-Dom imports
import { Route, Switch, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "../lib/firebase";

// Pages Import
import Landing from "./Landing";
import Holding from "./Holding";
import HoldingTiktok from "./HoldingTiktok";
import ProductSquareMeter from "./ProductSquareMeter";
import ProductKhitab from "./ProductKhitab";
import ProductComingSoon from "./ProductComingSoon";
import ThemedPrivacy from "./ThemedPrivacy";
import ThemedTOS from "./ThemedTOS";
import ThemedContact from "./ThemedContact";
import Team from "./Team";

// Vertical landing pages
import { ClinicsLanding, RealEstateLanding } from "./VerticalLanding";
import WhatsAppPOC from "./WhatsAppPOC";
import WhatsAppDashboard from "./WhatsAppDashboard";

// Legacy pages (for /tiktok route with MDL layout)
import ContactUs from "./ContactUs";
import Privacy from "./Privacy";
import TOS from "./TOS";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location]);
  return null;
}

const Main = () => (
  <>
  <RouteTracker />
  <Switch>
    {/* Holding company pages (themed) */}
    <Route exact path="/" component={Holding} />
    <Route exact path="/holding" component={Holding} />
    <Route exact path="/holding-tiktok" component={HoldingTiktok} />
    <Route exact path="/square-meter" component={ProductSquareMeter} />
    <Route exact path="/khitab" component={ProductKhitab} />
    <Route exact path="/coming-soon" component={ProductComingSoon} />
    <Route exact path="/privacy" component={ThemedPrivacy} />
    <Route exact path="/terms" component={ThemedTOS} />
    <Route exact path="/contact" component={ThemedContact} />
    <Route exact path="/team" component={Team} />

    {/* Vertical landing pages */}
    <Route exact path="/clinics" component={ClinicsLanding} />
    <Route exact path="/real-estate" component={RealEstateLanding} />
    <Route exact path="/whatsapp" component={WhatsAppPOC} />
    <Route exact path="/saree" component={WhatsAppPOC} />
    <Route exact path="/saree/dashboard" component={WhatsAppDashboard} />

    {/* Legacy TikTok approval pages (MDL layout) */}
    <Route exact path="/tiktok" component={Landing} />
    <Route exact path="/tiktok/contact" component={ContactUs} />
    <Route exact path="/tiktok/privacy" component={Privacy} />
    <Route exact path="/tiktok/terms" component={TOS} />
    <Route exact path="/help" component={Landing} />
  </Switch>
  </>
);

export default Main;
